import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.0178 9.26748H13.7235C14.4285 9.26748 15 8.69595 15 7.99094C15 7.28592 14.4285 6.71439 13.7235 6.71439H4.01473L6.66194 3.95417C7.15963 3.40279 7.12245 2.77501 6.66194 2.32689C6.20143 1.8767 5.42496 1.90561 4.99336 2.32689C4.56176 2.74816 0.344868 7.17569 0.344868 7.17569C0.115644 7.39872 0 7.69403 0 7.98933C0 8.28257 0.115644 8.57788 0.344868 8.80297C0.344868 8.80297 4.56176 13.2305 4.99336 13.6497C5.42496 14.071 6.20143 14.0999 6.66194 13.6497C7.12245 13.2016 7.15963 12.5738 6.66194 12.0245L4.0178 9.26748Z",
		fill: "currentColor"
	})
});
export default SvgIconArrowLeft;
